import React, { useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import moment from 'moment';

import { useAppSelector } from 'redux/hooks';
import { useDispatch } from 'react-redux';
import { getInspectionTaskDetails, getSelectedReportList, getSystems, getTechnicians, setLinkedReportsData } from 'redux/pages/Inspection/InspectionTask/inspectionTaskSlice';
import { getContractDetails } from 'redux/pages/Inspection/Contracts/contractSlice';
import { checkSystemInUse, checkXMLImportInProgress, deleteXMLFile, getUploadedXMLFileList, onAddSystem, onUploadSystemXml, setNewInspectionSystemData, setUploadedXmlFileList } from 'redux/pages/Inspection/Systems/systemSlice';

import { BsExclamationCircleFill, BsPaperclip, BsPlusLg } from 'react-icons/bs';

import AddModal from 'components/Table/AddModal/AddModal';
import InspectionReports from './InspectionReports';
import InformationBox from 'components/common/Message/InformationBox/InformationBox';
import ContractDate from './ContractDate';
import ConfirmationBox from 'components/common/Message/ConfirmationBox/ConfirmationBox';
import UploadXML from 'pages/Systems/ManageSystem/UploadXML';
import AddSystems from 'pages/Systems/ManageSystem/AddSystem';
import { showUI,sanitize } from 'service/GeneralUtility';
import { USATaskPattern,CanadaTaskPattern } from './InspectionTaskNumberPattern';
import { useNavigate } from 'react-router-dom';

interface Props {
    showModal: boolean,
    setShowModal: (state: boolean) => void,
    selectedRows: any,
    uniqueContractId: string,
    uniqueCustomerId: string,
    customerName: string,
    contractName: string,
    onEditInspectionTaskClick: (data: any) => void,
}

type FormData = {
    uniqueCustomerId: string,
    uniqueContractId: string,
    inspectionTaskName: string,
    uniqueSystemId: string,
    uniqueTechnicianId: any,
    plannedStartDate: any,
    plannedEndDate: any,
    notificationNumber: any,
    quantityOfTech: number,
    isTechRequiredAtPanel: boolean,
    status: string,
    reportIds: any,
    activate: boolean,
    activeSiteId:any
};

export const EditInspectionTask: React.FC<Props> = ({
    showModal = false,
    setShowModal = () => { },
    selectedRows = [],
    uniqueContractId = '',
    uniqueCustomerId = '',
    customerName = '',
    contractName = '',
    onEditInspectionTaskClick = () => { },
}) => {

    const {
        control,
        handleSubmit,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useForm<FormData>({
        defaultValues: {
            uniqueCustomerId: uniqueCustomerId,
            uniqueContractId: uniqueContractId,
            inspectionTaskName: '',
            uniqueSystemId: '',
            uniqueTechnicianId: '',
            plannedStartDate: null,
            plannedEndDate: null,
            notificationNumber: '',
            quantityOfTech: 1,
            isTechRequiredAtPanel: false,
            status: '',
            reportIds: [],
            activate: false,
            activeSiteId:''
        }
    });

    const technicianData = useAppSelector((state) => state.inspectionTask.technicianData);
    const isSystemInUse = useAppSelector((state) => state.system.systemInUse);
    const contractDetails = useAppSelector((state) => state.contract.contractDetails);
    const inspectionTaskDetails = useAppSelector((state) => state.inspectionTask.inspectionTaskDetails);
    const selectedReportList = useAppSelector((state) => state.inspectionTask.selectedReportList);
    const XMLImportInProgress = useAppSelector((state) => state.system.XMLImportInProgress);
    const uploadedXmlFileList = useAppSelector((state) => state.system.uploadedXmlFileList);
    const userPrivileges = useAppSelector((state) => state.user.userPrivileges);
    const systemData = useAppSelector((state) => state.inspectionTask.systemsData);
    const newSystemData = useAppSelector((state) => state.system.newSystemData);
    const loggedInUserDetails = useAppSelector((state) => state.administration.loggedInUserDetails);

    const [showPatternModal, setShowPatternModal] = useState<boolean>(false);
    const [showReportsModal, setShowReportsModal] = useState<boolean>(false);
    const [selectedReports, setSelectedReports] = useState<any>(null);
    const [technicianLookup, setTechnicianLookup] = useState([])
    const [displayInfoModal, setDisplayInfoModal] = useState(false);
    const [message, setMessage] = useState("");
    const [submitData, setSubmitData] = useState<any>("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [systemName, setSystemName] = useState(false);
    const [statusDisabled, setStatusDisabled] = useState(false);
    const [showContractDate, setShowContractDate] = useState(false);
    const [displayConfirmModal, setDisplayConfirmModal] = useState(false);
    const [contractData, setContractData] = useState<any>([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showUploadXMLModal,setShowUploadXMLModal]=useState<boolean>(false);
    const [selectedSystemId, setSelecteedSystemId] = useState("");
    const [isClosed, setIsClosed] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isFileUpload,setIsFileUpload]=useState(false);
    const [isXMLReUpload, setIsXMLReUpload] = useState(false);
    const [isUploadXMLData, setIsUploadXMLData] = useState<any>("");
    const [isshowProceedModal, setIsshowProceedModal] = useState(false);
    const [systemLookup, setSystemLookup] = useState([{ name: "", code: "" ,systemType:"" }]);
    const [systemListLookup, setSystemListLookup] = useState([{ name: "", code: "" ,systemType:""}]);
    const [showAddSystem, setShowAddSystem] = useState(false);
    const [isAdd,setIsAdd]=useState(false);
    const isActivate = watch("activate");
    const [pattern, setPattern] = useState<any>([]);
    const [inspectiontaskNumberPattern, setInspectiontaskNumberPattern] = useState<any>();
    const [showNotificationNumber, setShowNotificationNumber] = useState(false);
    const [countryId, setCountryId] = useState<any>()
    const [IsErrorCode, setIsErrorCode] = useState(false);
    const navigate = useNavigate();

    const editForm: any = useRef();
    const dispatch = useDispatch<any>();

    useEffect(() => {
        setValue("plannedStartDate", new Date(selectedRows[0]?.plannedStartDate?.replace(/-/g, '\/')))
        setValue("plannedEndDate", new Date(selectedRows[0]?.plannedEndDate?.replace(/-/g, '\/')))
        let body={
         UniqueContractId:uniqueContractId,
        }
        dispatch(getTechnicians(body))
        dispatch(getContractDetails(uniqueContractId))
        dispatch(getInspectionTaskDetails(selectedRows[0]?.uniqueInspectionTaskId))
        dispatch(getSelectedReportList(selectedRows[0]?.uniqueInspectionTaskId))
        setSystemName(selectedRows[0]?.system?.systemName);
        dispatch(checkSystemInUse(selectedRows[0]?.system?.uniqueSystemId));
        setSelecteedSystemId(selectedRows[0]?.system?.uniqueSystemId)
        if (selectedRows[0].status === "Completed") {
            dispatch(getSystems())
            setIsCompleted(true)
        } else if (selectedRows[0].status === "Closed") {
            setIsClosed(true)
        }
    }, [dispatch, uniqueContractId, selectedRows])

    useEffect(() => {
        if (inspectionTaskDetails && inspectionTaskDetails?.uniqueInspectionTaskId === selectedRows[0]?.uniqueInspectionTaskId) {
            let systemId = inspectionTaskDetails?.system?.uniqueSystemId
            setValue("inspectionTaskName", inspectionTaskDetails.inspectionTaskName)
            setValue("uniqueSystemId", systemId)
            const foundItem = technicianData.find(item => item.uniqueUserId === inspectionTaskDetails.techUniqueId);
            if (foundItem == undefined) {
                setValue("uniqueTechnicianId", null)
            }
            else {
                setValue("uniqueTechnicianId", inspectionTaskDetails.techUniqueId)
            }
            setValue("notificationNumber", inspectionTaskDetails.notificationNumber ? inspectionTaskDetails.notificationNumber:"")
            setValue("quantityOfTech", inspectionTaskDetails.qtyOfTech)
            setValue("isTechRequiredAtPanel", inspectionTaskDetails.isTechRequiredAtPanel)
            if (selectedRows[0]?.status === "Active") {
                setValue("activate", true)
                setStatusDisabled(true);
            } else {
                setValue("activate", false)
                setStatusDisabled(false);
            }
        }
        if (contractDetails && contractDetails?.contractNumber) {
            setContractData(contractDetails)
            if (Object.keys(contractDetails).length !== 0 &&
                countryId === 220 && contractDetails?.contractNumber.startsWith("44OP") ||
                countryId === 220 && contractDetails?.contractNumber.startsWith("44OC") ||
                countryId === 38 && contractDetails?.contractNumber.startsWith("60") ||
                countryId === 38 && /^[a-zA-Z][-][0-9]{2}[-][a-zA-Z][-][0-9]{4}$/.test(contractDetails?.contractNumber) ||
                countryId === 38 && /^[a-zA-Z][-]SI[-][0-9]{5}$/.test(contractDetails?.contractNumber) ||
                countryId === 38 && contractDetails?.contractNumber.startsWith("13")) {
                setShowNotificationNumber(false);
            } else {
                setShowNotificationNumber(true);
            }
            if(contractDetails?.status!=="Active"){
                setValue("activate", false)
                setStatusDisabled(true);
            }
   
        }
    }, [inspectionTaskDetails, contractDetails,countryId,setValue])

    useEffect(() => {
        if (selectedReportList?.reportDetails?.length>0) {
            setSelectedReports(selectedReportList?.reportDetails)
            let reportList = JSON.parse(JSON.stringify(selectedReportList?.reportDetails))
            let selectedReportId: any = [];
            reportList.map((item: any) => {
                return selectedReportId.push(item.inspectionReportId)
            })
            setValue("reportIds", selectedReportId)
        }
    }, [selectedReportList, setValue])

    useEffect(() => {
        if (technicianData?.length > 0) {
            let technician: any = [];
            technicianData.map((item: any) => {
                return technician.push({ name: item.formattedLeadTechnicianName, code: item.uniqueUserId })
            })
            setTechnicianLookup(technician)
        }
    }, [technicianData])

    useEffect(() => {
        if (systemData?.length > 0) {
            let system: any = [];
            systemData.map((item: any) => {
                return system.push({ name: item.systemName, code: item.uniqueSystemId,systemType:item.systemType })
            })
            setSystemLookup(system)
            setSystemListLookup(system)
        }
    }, [systemData])

    useEffect(() => {

    }, [])

    useEffect(() => {
        if (isActivate && isSystemInUse && selectedRows[0]?.status !== "Active") {
            if (isSystemInUse?.isActiveTaskExists) {
                setMessage("An active Inspection Task already exists for this System, cannot activate the selected Task");
                setDisplayInfoModal(true);
                setValue("activate", false)
            }
        }
    }, [isActivate, isSystemInUse])


    const formSubmitHandler = (data: any) => {
        editForm.current.requestSubmit();
    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <span className="tooltip-text"><BsExclamationCircleFill />{errors[name].message}</span>
    };

    const onEditFormSubmit = (data: any) => {
        data.inspectionTaskName=sanitize(data.inspectionTaskName)
        if (data.activate)
            data.status = 1
        else
          data.status = inspectionTaskDetails.statusId
        data.qtyOfTech = data.quantityOfTech;
        data.plannedStartDate = moment(data?.plannedStartDate).format("YYYY-MM-DD").toString()
        data.plannedEndDate = moment(data?.plannedEndDate).format("YYYY-MM-DD").toString()
        data.activeSiteId= loggedInUserDetails?.userDefaults?.uniqueSiteId;
        setStartDate(data.plannedStartDate);
        setEndDate(data.plannedEndDate);
        if (data.reportIds.length === 0) {
            setMessage("Reports are not mapped for the selected Inspection Task, cannot be activated");
            setDisplayInfoModal(true);
        } else if (new Date(data.plannedStartDate) > new Date(data.plannedEndDate)) {
            setMessage("Planned End Date should be greater than Planned Start Date");
            setDisplayInfoModal(true);
        } else if (new Date(data.plannedStartDate?.replace(/-/g, '\/')) < new Date(contractData?.startDate?.replace(/-/g, '\/')) || new Date(data.plannedEndDate?.replace(/-/g, '\/')) > new Date(contractData?.endDate?.replace(/-/g, '\/'))) {
            if (showUI(userPrivileges,'SIETAP_FS_CONTRACT_DATE_UPDATE')) {
                setMessage("Inspection Task Planned End Date or Start Date is not within the Contract Start and End Date. Do you want to change the Contract Start and End Dates?");
                setDisplayConfirmModal(true);
            }
            else {
                setMessage("Planned Start and End Date of the Inspection task is not within the Start and End Date of Contract. Contact TAP Admin to update the Contract");
                setDisplayInfoModal(true);
            }
        } else {
            setSubmitData(data);
            setIsSubmit(true);
            setIsSaving(true);
            dispatch(checkSystemInUse(data.uniqueSystemId));
        }
    };

    useEffect(() => {
        if (isCompleted && isSubmit && Object.keys(isSystemInUse).length !== 0 && isSystemInUse?.uniqueSystemId === submitData?.uniqueSystemId) {
            if (isSystemInUse.isActiveTaskExists) {
                setMessage("An active Inspection Task already exists for this System, cannot activate the selected Task");
                setDisplayInfoModal(true);
            } else if (!isSystemInUse.isInspectionTaskCompleted) {
                setMessage("Inspection Task not completed for this System, cannot add an active Inspection Task");
                setDisplayInfoModal(true);
            } else if (!isSystemInUse.isXMLFileUploaded && isSystemInUse.isSiemens) {
                setMessage("XML File is not uploaded for the System, cannot activate the Inspection Task");
                setDisplayInfoModal(true); 
            }else {
                onEditInspectionTaskClick && onEditInspectionTaskClick(submitData)
            }
            setIsSubmit(false)
        } else if (isSubmit && Object.keys(isSystemInUse).length !== 0) {
            if (!isSystemInUse.isXMLFileUploaded && isSystemInUse.isSiemens) {
                setMessage("XML File is not uploaded for the System, cannot activate the Inspection Task");
                setDisplayInfoModal(true);
            } else {
                let updatedSubmitData = {...submitData}
                if (updatedSubmitData.inspectionTaskName) {
                updatedSubmitData.inspectionTaskName?.trim();
                }
                onEditInspectionTaskClick && onEditInspectionTaskClick(updatedSubmitData)
            }
            setIsSubmit(false)
        }
    }, [isSystemInUse, submitData])

    const onContractUpdated = (data) => {
        setShowContractDate(false);
        setMessage("Contract updated")
        setDisplayInfoModal(true);
        let contractInfo = JSON.parse(JSON.stringify(contractData))
        contractInfo.startDate = data.contractStartDate;
        contractInfo.endDate = data.contractEndDate;
        setContractData(contractInfo);
    }

    const saveReportClick = (selections) => {
        setShowReportsModal(false)
        let selectedReportId: any = [];
        selections.map((item: any) => {
            return selectedReportId.push(item.inspectionReportId.toString())
        })
        setValue("reportIds", selectedReportId);
        setSelectedReports(selections);
        dispatch(setLinkedReportsData(""))
    }

    const onUploadClick = (event) => {
        event?.preventDefault();
        dispatch(setUploadedXmlFileList(""))
        if (selectedRows[0]?.panelType === "MXL" || selectedRows[0]?.panelType === "XLS" || selectedRows[0]?.panelType === "Desigo FS20" ||
            selectedRows[0]?.panelType === "Desigo FV20" || selectedRows[0]?.panelType === "Desigo Modular" || selectedRows[0]?.panelType === "Cerberus PRO FC92" ||
            selectedRows[0]?.panelType === "Cerberus PRO FV92" || selectedRows[0]?.panelType === "Cerberus PRO Modular") {
            dispatch(checkXMLImportInProgress(selectedSystemId));
            setIsFileUpload(true);
        } else {
            setMessage("System Type of selected System is not MXL/XLS/Desigo FS20/Desigo FV20/Desigo Modular/Cerberus PRO FC92/Cerberus PRO FV92/Cerberus PRO Modular, cannot upload the XML file")
            setDisplayInfoModal(true)
        }
    }

    useEffect(()=>{
        if (isFileUpload && Object.keys(XMLImportInProgress).length !== 0) {
            if (XMLImportInProgress.isSystemParseInProgress === true) {
              setMessage("XML importing is in progress, XML file cannot be uploaded");
              setDisplayInfoModal(true);
            }
            else{
              dispatch(getUploadedXMLFileList(selectedSystemId, false))
              setShowUploadXMLModal(true);
            }
            setIsFileUpload(false);
          }
     },[isFileUpload,XMLImportInProgress])

     const onUploadXml = (data: any) => {        
        dispatch(onUploadSystemXml(selectedSystemId,loggedInUserDetails?.userDefaults?.uniqueSiteId, data, setShowUploadXMLModal, setMessage, setDisplayInfoModal,setDisplayConfirmModal, setIsXMLReUpload,setIsUploadXMLData,setIsshowProceedModal,false,isXMLReUpload));
    }

    const onDeleteFileClick = (data: any) => {
        dispatch(deleteXMLFile(selectedSystemId, data?.fileId, false,loggedInUserDetails?.userDefaults?.uniqueSiteId, setMessage, setDisplayInfoModal, setShowUploadXMLModal))
    }

    const onAddSystemClick = (event) => {
        event?.preventDefault();
        setShowAddSystem(true)
    }

    const onAddSystemData = (submitData: any) => {
        dispatch(onAddSystem(
            submitData,
            setMessage,
            setDisplayInfoModal,
            setDisplayConfirmModal,
            setShowAddSystem,
            setIsAdd,
            setIsErrorCode
        ));
    }

    useEffect(() => {
        if (newSystemData) {
            let system: any = systemListLookup;
            let newSystem:any={name: "", code: "",systemType:""}
            system.push({ name: newSystemData?.systemName, code: newSystemData?.uniqueSystemId,systemType:newSystemData?.systemType})
            setSystemLookup(system)
            setValue("uniqueSystemId", newSystemData?.uniqueSystemId)
            setSelecteedSystemId(newSystemData?.uniqueSystemId)
            newSystem[0]={ name: newSystemData?.systemName, code: newSystemData?.uniqueSystemId,systemType:newSystemData?.systemType}
            dispatch(setNewInspectionSystemData(""))
        }
    }, [newSystemData, setValue, systemListLookup])

    const handleSystemChange=(value)=>{
        let system:any=[]
        setSelecteedSystemId(value)
        systemLookup.map((item)=>{
            if(item.code===value)
                system.push({ name: item.name, code: item.code,systemType:item.systemType})
        })        
    }

    useEffect(() => {
        if (loggedInUserDetails) {
            let countryId: any = Number;
            countryId = loggedInUserDetails?.userDefaults?.countryId;
            setCountryId(loggedInUserDetails?.userDefaults?.countryId);
            if (countryId === 38) {
                setPattern(CanadaTaskPattern);
                setInspectiontaskNumberPattern(/^((600)[0-9]{6}|[5][0-9]{9})$/);
            } else if (countryId === 220) {
                setPattern(USATaskPattern);
                setInspectiontaskNumberPattern(/^[5][0-9]{9}$/);
            }
        }
    }, [loggedInUserDetails]);

    const onConfirmClick = (flag: string) => {
        if (flag) {
            if (flag === 'XML') {
                setShowUploadXMLModal(true);
                setIsAdd(false);
            } 
           else if(isXMLReUpload){
                setDisplayConfirmModal(false);
                setIsXMLReUpload(false);
                onUploadXml(isUploadXMLData);
                setIsshowProceedModal(false);
            }
            else if (flag === 'DATE'){
                setShowContractDate(true);
            }
        }
    };
    const onCancelClick = () => {
        if (isXMLReUpload) {
            setIsXMLReUpload(false);
            setDisplayConfirmModal(false);
            setIsshowProceedModal(false);
        }
    }

  const onHide = () => {
        if(IsErrorCode)
        {
            navigate(0);
             setDisplayInfoModal(false);
        }
        else{
            setDisplayInfoModal(false);
        }
    }
    const onOkClick = () => {
        setDisplayInfoModal(false);
        if (IsErrorCode) {
            navigate(0);
        }
    }
    const onError = (errors: any, e: any) => { };

    return (
        <>
            <AddModal
                header='Edit Inspection Task'
                showModal={showModal}
                isAdd={false}
                setShowModal={setShowModal}
                style={{ width: '35vw', maxHeight: '100%' }}
                OnSaveClick={formSubmitHandler}
                loader={isSaving}

            >
                <form onSubmit={handleSubmit(onEditFormSubmit, onError)} ref={editForm}>
                    <Dialog
                        header="Notification Number"
                        visible={showPatternModal}
                        onHide={() => setShowPatternModal(false)}
                        className='pattern-overlay'
                        style={{ width: '32vw' }}
                    >
                        <DataTable showGridlines={false} value={pattern}>
                            <Column field="pattern" header="Pattern" />
                            <Column field="format" header="Format" />
                            <Column field="description" header="Description" />
                        </DataTable>
                    </Dialog>

                    {showReportsModal && (<InspectionReports
                        showModal={showReportsModal}
                        setShowModal={setShowReportsModal}
                        selectedReports={selectedReports}
                        selectedRows={selectedRows}
                        saveReportClick={saveReportClick}
                        isAdd={false}
                    />)}

                    <div className="row px-2">
                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label text-container">
                                <label htmlFor="inputtext">Customer</label>
                                <Controller
                                    name="uniqueCustomerId"
                                    control={control}
                                    render={() => (
                                        <span className='text-value'>{customerName}</span>
                                    )} />
                            </span>
                        </div>
                    </div>

                    <div className="row px-2">
                        <div className="field col-12 md:col-2 mb-0 py-0">
                            <span className="p-float-label text-container">
                                <label htmlFor="inputtext">Contract</label>
                                <Controller
                                    name="uniqueContractId"
                                    control={control}
                                    render={() => (
                                        <span className='text-value'>{contractName}</span>
                                    )} />
                            </span>
                        </div>
                    </div>

                    <div className="row px-2 pt-2">
                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="inspectionTaskName"
                                    control={control}
                                    rules={{
                                        required: 'Name is required.',
                                        validate: (value) => {
                                            return value.trim().length<=0
                                              ?"Name is required.":true
                                          }
                                    }}

                                    render={({ field, fieldState }) => (
                                        <InputText
                                            id="inspectionTaskName"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                        />
                                    )} />
                                <label className='mandatory' htmlFor="inputtext">Name</label>
                                {getFormErrorMessage('inspectionTaskName')}
                            </span>
                        </div>
                    </div>

                    {!isCompleted && (<div className="row px-2 d-flex align-items-center">
                        <div className="field col-11 md:col-10 mb-0 pb-3 field-system-disable">
                            <span className="p-float-label text-container">
                                <label htmlFor="inputtext">System</label>
                                <Controller
                                    name="uniqueSystemId"
                                    control={control}
                                    render={() => (
                                        <span className='text-value'>{systemName}</span>
                                    )} />
                            </span>
                        </div>
                        {isClosed ? (
                        <div className="field col-1 md:col-2 mb-0 p-0 pb-2 d-flex">
                            <span className="p-float-label action-btns">
                                <Button className='button-icon' onClick={(e)=>onUploadClick(e)}>
                                    <BsPaperclip className='icon' />
                                </Button>
                            </span>
                        </div>): null}
                    </div>)}

                    {isCompleted && (<div className="row px-2 pt-2 d-flex align-items-center">
                        <div className="field col-10 md:col-10 mb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="uniqueSystemId"
                                    control={control}
                                    rules={{
                                        required: 'System is required.'
                                    }}

                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            inputId="system"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => {field.onChange(e.value);handleSystemChange(e.value)}}
                                            options={systemLookup}
                                            optionLabel="name"
                                            optionValue='code'
                                        />

                                    )} />
                                <label className='mandatory' htmlFor="dropdown">System</label>
                                {getFormErrorMessage('uniqueSystemId')}
                            </span>
                        </div>
                        <div className="field col-2 md:col-2 mb-0 p-0 d-flex">
                            <span className="p-float-label action-btns mr-1">
                                <Button className='button-icon' onClick={onAddSystemClick}>
                                    <BsPlusLg className='icon' />
                                </Button>
                            </span>
                            <span className="p-float-label action-btns">
                                <Button className='button-icon' onClick={onUploadClick}>
                                    <BsPaperclip className='icon' />
                                </Button>
                            </span>
                        </div>
                    </div>)}


                    <div className="row px-2">
                        <div className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <Controller
                                    name="plannedStartDate"
                                    control={control}
                                    rules={{
                                        required: 'Planned Start Date is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Calendar
                                            id="plannedStartDate"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            dateFormat="yy-mm-dd"
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)} />
                                    )} />
                                <label className='mandatory' htmlFor="calendar">Planned Start Date</label>
                                {getFormErrorMessage('plannedStartDate')}
                            </span>
                        </div>
                    </div>

                    <div className="row px-2">
                        <div className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <Controller
                                    name="plannedEndDate"
                                    control={control}
                                    rules={{
                                        required: 'Planned End Date is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Calendar
                                            id="plannedEndDate"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            dateFormat="yy-mm-dd"
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)} />
                                    )} />
                                <label className='mandatory' htmlFor="calendar">Planned End Date</label>
                                {getFormErrorMessage('plannedEndDate')}
                            </span>
                        </div>
                    </div>

                    {showNotificationNumber? (<div className="row px-2 py-2">
                        <div className="field col-12 md:col-2 mb-0 pb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="notificationNumber"
                                    control={control}
                                    rules={{
                                        required:'Notification Number is required',
                                        pattern: { value: inspectiontaskNumberPattern, message: 'Enter a valid Notification Number' }
                                    }}

                                    render={({ field, fieldState }) => (
                                        <InputText
                                            id="notificationNumber"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                        />
                                    )} />
                                <label className='mandatory' htmlFor="inputtext">Notification Number</label>
                                {getFormErrorMessage('notificationNumber')}
                            </span>
                        </div>
                        <div className='row p-0'>
                            <div className="field col-12 md:col-2 py-0 text-right m-0 p-0">
                                <Button label="View Pattern" aria-label="View Pattern" className='check-btnLink' onClick={e => {
                                    e.preventDefault();
                                    setShowPatternModal(true);
                                }} />
                            </div>
                        </div>
                    </div>):null}

                    <div className="row px-2">
                            <div className="field col-12 md:col-4">
                                <div className="field-checkbox px-2">
                                    <Controller
                                        name="isTechRequiredAtPanel"
                                        control={control}
                                        render={({ field }) => (
                                            <Checkbox
                                                inputId="binary"
                                                checked={field.value}
                                                {...field}
                                            />
                                        )} />
                                    <label className='mandatory' htmlFor="binary">Requires a Technician at the Panel</label>
                                </div>
                            </div>
                        </div>

                    <div className="row px-2">
                        <div className="field col-12 md:col-2 mb-0 py-0">
                            <span className="p-float-label">
                                <Controller
                                    name="quantityOfTech"
                                    control={control}
                                    rules={{
                                        required: 'Qty of Techs is required.',
                                        maxLength: 3,
                                        validate: () => {
                                            return getValues("quantityOfTech") <1 || getValues("quantityOfTech") >99
                                              ? "Enter a value between 1 and 99 in Qty of Techs"
                                              : undefined;
                                          },
                                    }}

                                    render={({ field, fieldState }) => (
                                        <InputNumber
                                            inputId="inputnumber"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)} />
                                    )} />
                                <label className='mandatory' htmlFor="inputtext">Qty of Techs</label>
                                {getFormErrorMessage('quantityOfTech')}
                            </span>
                        </div>
                    </div>

                    <div className="row px-2 pt-2">
                        <div className="field col-12 md:col-2 mb-0 pb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="uniqueTechnicianId"
                                    control={control}
                                    rules={{
                                        required: 'Lead Technician is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            inputId="uniqueTechnicianId"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)}
                                            options={technicianLookup}
                                            optionLabel="name"
                                            optionValue="code"
                                        />
                                    )} />
                                <label className='mandatory' htmlFor="dropdown">Lead Technician</label>
                                {getFormErrorMessage('uniqueTechnicianId')}
                            </span>
                        </div>
                        <div className='row p-0'>
                            <div className="field col-12 md:col-2 py-0 text-right m-0 p-0">
                                <Button label={`Report Selected (${selectedReports?.length || 0})`} aria-label="Report Selected" className='check-btnLink' onClick={e => {
                                    e.preventDefault();
                                    setShowReportsModal(true);
                                }} />
                            </div>
                        </div>
                        <div className="row px-2">
                            <div className="field col-12 md:col-4">
                                <div className="field-checkbox px-2">
                                    <Controller
                                        name="activate"
                                        control={control}
                                        render={({ field }) => (
                                            <Checkbox
                                                disabled={statusDisabled}
                                                inputId="activateBox"
                                                checked={field.value}
                                                {...field}
                                            />
                                        )} />
                                    <label className='mandatory' htmlFor="activateBox">Activate</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </AddModal>
            {showUploadXMLModal && <UploadXML showModal={showUploadXMLModal} setShowModal={setShowUploadXMLModal} onUploadXmlClick={onUploadXml} uploadedFileList={uploadedXmlFileList} onDeleteFileClick={onDeleteFileClick} title="Upload XML File" typeFlag = "XML"/>}
            {showAddSystem && (<AddSystems showModal={showAddSystem} setShowModal={setShowAddSystem} onAddSystemClick={(data) => onAddSystemData(data)} />)}
            <InformationBox showInfoModal={displayInfoModal} setShowInfoModal={setDisplayInfoModal} message={message} okOnClick={onOkClick} onHide={onHide} />
            <ConfirmationBox showConfirmModal={displayConfirmModal} setShowConfirmModal={setDisplayConfirmModal} confirmAction={()=> {onConfirmClick(isAdd ? 'XML' : 'DATE'); setDisplayConfirmModal(false)}} cancelAction={onCancelClick} onHideAction = {onCancelClick} message={message} />
            {showContractDate && (<ContractDate showModal={showContractDate} setShowModal={setShowContractDate} contractDetails={contractData} plannedStartDate={startDate} plannedEndDate={endDate} onContractUpdated={onContractUpdated}/>)}
        </>
    );
}

export default EditInspectionTask;